<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <div class="text-center">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" @click="overlay = false"></v-progress-circular>
          </v-overlay>
        </div>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense>
        <p style="font-size:30px; color: white;" class="mb-0">Empresas Contratistas</p>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="d-flex justify-end">
        <v-btn-toggle class="mb-0 pb-0" center>
          <v-btn @click="registro=true">Registro</v-btn>
          <v-btn @click="registro=false">Listado</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" v-if="registro">
        <v-card mx-auto outlined>
          <v-row dense class="ma-3">
            <v-col cols="12" md="12" sm="12" xs="12" lg="8" xl="8">
              <v-autocomplete
                v-model="id_empresa_contratista"
                :items="empresascontratistas"
                :search-input.sync="searchempresa"
                flat
                outlined
                dense
                clearable
                prepend-inner-icon="mdi-magnify"
                hide-no-data
                hide-details
                label="Buscar empresa contratista ..."
                solo-inverted
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="4" xl="4" class="d-flex justify-end">
              <v-btn-toggle>
                <v-btn @click="editItem">Consultar</v-btn>
                <v-btn @click="limpiar">Nuevo</v-btn>
              </v-btn-toggle>
            </v-col>
            <!-- Informacion personal -->
            
            <v-col cols="12" md="12" sm="12" xs="12" class="pt-5" dense>
              <span class="font-weight-bold primary--text">Datos generales</span>
              <v-row dense>
                <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense>
                          <v-text-field
                            v-model="empresa_contratista"
                            label="Empresa Contratista Solicitante"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-domain"
                            class="pt-0"
                            :rules="[
                              () => !!empresa_contratista || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="empresa_contratista"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense>
                          <v-text-field
                            v-model="ruc_contratista"
                            label="RUC del Contratista"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-card-account-details"
                            class="pt-0"
                            :rules="[
                              () => !!ruc_contratista || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="ruc_contratista"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense>
                          <v-text-field
                            v-model="representante_contratista"
                            label="Representante Legal del Contratista"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-account"
                            class="pt-0"
                            :rules="[
                              () => !!representante_contratista || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="representante_contratista"
                            required
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense>
                          <v-text-field
                            v-model="celular_contratista"
                            label="Celular"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-phone"
                            class="pt-0"
                            :rules="[
                              () => !!celular_contratista || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="celular_contratista"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense>
                          <v-text-field
                            v-model="representante_sitio_contratista"
                            label="Representante en Sitio del Contratista"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-account-hard-hat"
                            class="pt-0"
                            :rules="[
                              () => !!representante_sitio_contratista || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="representante_sitio_contratista"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense>
                          <v-text-field
                            v-model="celular_sitio_contratista"
                            label="Celular"
                            outlined dense hide-details
                            prepend-inner-icon="mdi-phone"
                            class="pt-0"
                            :rules="[
                              () => !!celular_sitio_contratista || 'Campo requerido',
                            ]"
                            :error-messages="errorMessages"
                            ref="celular_sitio_contratista"
                            required
                          ></v-text-field>
                        </v-col> -->
                        <v-col cols="12" md="12" sm="12" xs="12" dense>
                          <v-file-input
                            v-model="logo_empresa"
                            label="Logo de la empresa"
                            outlined
                            dense
                            accept="image/*"
                            prepend-inner-icon="mdi-image"
                            show-size
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12" v-if="logo_url" class="text-center">
                          <v-img
                            :src="logo_url"
                            max-width="120"
                            max-height="120"
                            contain
                            class="mx-auto"
                          ></v-img>
                        </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn color="primary" class="mb-5" @click="save" :disabled="overlay2">Guardar</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" dense v-else>
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="empresa_headers"
                :items="empresa_item"
                :search="searchempresas"
                sort-by="razonsocial"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2">Empresa</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-dialog v-model="adModal" max-width="290px">
                      <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">
                          <span class=".font-weight-thin">¿Activar item?</span>
                        </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">
                          <span class=".font-weight-thin">¿Desactivar item?</span>
                        </v-card-title>
                        <v-card-text>
                          Estas a punto de
                          <span v-if="adAccion==1">activar</span>
                          <span v-if="adAccion==2">desactivar</span>
                          el item asoaciado a
                          <strong>{{adNombre}}</strong>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            outlined
                            @click="ActivarDesactivarCerrar()"
                          >Cancelar</v-btn>
                          <v-btn
                            v-if="adAccion==1"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Activar()"
                          >Activar</v-btn>
                          <v-btn
                            v-if="adAccion==2"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Desactivar()"
                          >Desactivar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchempresas"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <!-- Template para condicion -->
                <template v-slot:item.condicion="{ item }">
                  <v-switch v-model="item.condicion" inset @change="ActivarDesactivar(item)"></v-switch>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemEmpresa(item)"
                  >mdi-square-edit-outline</v-icon>
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color">
        <v-icon dark class="pr-5">{{icon}}</v-icon>
        {{error}}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
//Nuestro codigo Vue
const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
})
export default {
  data() {
    return {
      //Ayuda
      registro: true,
      nuevo: true,
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      overlay: false,
      overlay2: false,
      snackbar: false,
      error: null,
      empresascontratistas: [],
      empresa_contratista: "",
      ruc_contratista: "",
      representante_contratista: "",
      celular_contratista: "",
      representante_sitio_contratista: "",
      celular_sitio_contratista: "",
      logo_empresa: null,
      logo_url: null,
      id_empresa_contratista: "",
      errorMessages: "",
      color: "#2A3B4D",
      icon: "mdi-thumb-up",
      dialogcontratosempresas: false,
      pattern: '/[A-Z]/\\W',

      //Tablas
      empresa_headers: [
        { text: "Razón Social del Contratista", value: "empresa_contratista" },
        { text: "RUC del Contratista", value: "ruc_contratista" },
        { text: "Representante Legal del Contratista", value: "representante_contratista" },
        { text: "Celular", value: "celular_contratista" },
        { text: "Representante en Sitio del Contratista", value: "representante_sitio_contratista" },
        { text: "Celular Representante en Sitio", value: "celular_sitio_contratista" },
      ],
      empresa_item: [],
      
      /*Empresa */
      searchempresa: "",
      searchempresas: "",
      editedIndex: -1,
      idempresa: "",
      ruc: "",
      razonsocial: "",
      abreviatura: "",
      nombrecompleto: "",
      representante: "",
      representante_dni: "",
      representante_cel: "",
     /*Soporte*/
      valida: 0,
      validamensaje: [],
      editedIndexDetalle: -1,
      loading: false
    };
  },
  created() {
    this.listar();
    this.selectempresa();
    let me = this;
    // Add a request interceptor
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        me.overlay2 = true;
        return config;
      },
      function (error) {
        // Do something with request error
        me.overlay2 = false;
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay2 = false;
        //me.overlay=false;
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
        me.overlay2 = false;
      }
    );
  },

  computed: {
    form1() {
      return {
        ruc_contratista: this.ruc_contratista,
        empresa_contratista: this.empresa_contratista,
       };
    }
  },
  methods: {
    validar1() {
      /*Validacion Forms */
      this.error = null;
      this.form1HasErrors = false;

      Object.keys(this.form1).forEach((f) => {
        if (!this.form1[f]) this.form1HasErrors = true;

        const ref = this.$refs[f];

        if (ref && typeof ref.validate === "function") {
          ref.validate(true);
        } else {
          console.warn(`El ref '${f}' no existe o no tiene validate()`);
        }
      });
    },

    editItemEmpresa(item) {
      this.overlay = true;
      this.idempresa = item.idempresa;
      this.registro = true;
      this.editItem();
      this.overlay = false;
    },
    /* Tabla */
    listar() {
      let me = this;
      me.empresa_item=[];
      axios
        .get("api/Contratistas/Listar")
        .then(function (response) {
          me.empresa_item = response.data;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },

    selectempresa() {
      let me = this;
      var Array = [];
      me.empresascontratistas = [];
      axios
        .get("api/Contratistas/Select")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.empresascontratistas.push({ text: x.empresa_contratista, value: x.id_empresa_contratista });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error.response);
        });
    },

    editItem() {
      this.overlay = true;
      let me = this;
      var Array = [];
      axios
        .get("api/Contratistas/Mostrar/" + me.id_empresa_contratista)
        .then(function (response) {
          //console.log(response.data.idempresa);
          me.id_empresa_contratista = response.data.id_empresa_contratista;
          me.empresa_contratista = response.data.empresa_contratista;
          me.ruc_contratista = response.data.ruc_contratista;
          me.representante_contratista = response.data.representante_contratista;
          me.celular_contratista = response.data.celular_contratista;
          me.representante_sitio_contratista = response.data.representante_sitio_contratista;
          me.celular_sitio_contratista = response.data.celular_sitio_contratista;
          me.logo_url = response.data.logo_empresa;
          me.logo_empresa = null;
          me.editedIndex = 1;
          me.nuevo = false;
          me.mostrarInfo = true;
        })
        .catch(function (error) {
          console.log(error);
        });
      this.overlay = false;
    },
    editItemEmpresa(item) {
      this.id_empresa_contratista = item.id_empresa_contratista;
      this.empresa_contratista = item.empresa_contratista,
      this.ruc_contratista = item.ruc_contratista,
      this.representante_contratista = item.representante_contratista,
      // this.celular_contratista = item.celular_contratista,
      // this.representante_sitio_contratista = item.representante_sitio_contratista,
      // this.celular_sitio_contratista = item.celular_sitio_contratista,
      this.editedIndex = 1;
    },

    isTrue(value){
        if (typeof(value) === 'string'){
            value = value.trim().toLowerCase();
        }
        switch(value){
            case true:
            case "true":
            case 1:
            case "1":
            case "on":
            case "yes":
                return true;
            default: 
                return false;
        }
    },

    limpiar() {
      this.id_empresa_contratista = "";
      this.empresa_contratista = item.empresa_contratista,
      this.ruc_contratista = item.ruc_contratista,
      this.representante_contratista = item.representante_contratista,
      // this.celular_contratista = item.celular_contratista,
      // this.representante_sitio_contratista = item.representante_sitio_contratista,
      // this.celular_sitio_contratista = item.celular_sitio_contratista,
      this.editedIndex = -1;
      this.nuevo = true;
      this.mostrarInfo = false
    },
    async save() {
      this.validar1();
      if (this.form1HasErrors) return;

      let me = this;
      let formData = new FormData();

      formData.append("empresa_contratista", me.empresa_contratista);
      formData.append("ruc_contratista", me.ruc_contratista);
      formData.append("representante_contratista", me.representante_contratista);
      // formData.append("celular_contratista", me.celular_contratista);
      // formData.append("representante_sitio_contratista", me.representante_sitio_contratista);
      // formData.append("celular_sitio_contratista", me.celular_sitio_contratista);

      if (me.logo_empresa) {
        formData.append("logo", me.logo_empresa);
      }

      try {
        if (me.editedIndex > -1) {
          // 🔵 ACTUALIZAR
          formData.append("id_empresa_contratista", me.id_empresa_contratista);

          await axios.put("/api/Contratistas/Actualizar", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });
        } else {
          // 🟢 CREAR
          const response = await axios.post("/api/Contratistas/Crear", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });

          me.id_empresa_contratista = Number(response.data);
        }

        me.color = "#2A3B4D";
        me.icon = "mdi-thumb-up";
        me.error = "Registro exitoso";
        me.snackbar = true;
        me.nuevo = false;

        me.selectempresa();
        me.listar();

      } catch (error) {
        console.error(error);
        me.color = "#E53935";
        me.icon = "mdi-alert";
        me.error = error.response?.data || "Error al guardar";
        me.snackbar = true;
      }
    },

    abrirDialogContratosEmpresas() {
      this.dialogcontratosempresas = true;
      this.limpiarContratosEmpresas();
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    seleccionarArchivo(e) {
      this.archivo = e.target.files[0];
    },
    onFileChange(e) {
      this.logo_empresa = e.target.files[0];
    }
  },
};
</script>
<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}
.my-input {
  text-transform: uppercase;
}
.v-application .primary {
    background-color: #2D8C9E !important;
    border-color: #2D8C9E !important;
}
.v-application .primary--text {
    color: #2D8C9E !important;
    caret-color: #2D8C9E !important;
}
</style>